import { inject, Injectable } from '@angular/core';

import { ResourcesMenuResponse } from '@app-model/api';
import { IGetResourcesMenuRequest } from '@app-model/request';
import { BehaviorSubject } from 'rxjs';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ResourceService {
  private _apiService = inject(ApiService);

  resources: BehaviorSubject<ResourcesMenuResponse[]> = new BehaviorSubject<ResourcesMenuResponse[]>([]);

  getMenu(request: IGetResourcesMenuRequest): void {
    this._apiService.getResourceMenu(request).subscribe((menu: ResourcesMenuResponse[]) => this.resources.next(menu));
  }
}
